import React from 'react';
import { NavLink } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import domainConfig from './config/domainConfig';

const Navbar = ({ user, onLogout }) => {
  return (
    <AppBar position="static" color="default" elevation={1}>
      <Toolbar>
        <Typography variant="h6" sx={{ flexGrow: 1 }}>
          {domainConfig.brandName}
        </Typography>
        <Box>
          {!user && (
            <Button component={NavLink} to="/login" color="inherit" sx={{ mr: 1 }}>
              Login
            </Button>
          )}
          {!user && (
            <Button component={NavLink} to="/register" color="inherit" sx={{ mr: 1 }}>
              Register
            </Button>
          )}
          {user && (
            <Button component={NavLink} to="/dashboard" color="inherit" sx={{ mr: 1 }}>
              Dashboard
            </Button>
          )}
          {user && (
            <Button component={NavLink} to="/reports" color="inherit" sx={{ mr: 1 }}>
              Reports
            </Button>
          )}
          {user?.isAdmin && (
            <Button component={NavLink} to="/admin" color="inherit" sx={{ mr: 1 }}>
              Admin
            </Button>
          )}
          {user?.isAdmin && (
            <Button component={NavLink} to="/admin/report-permissions" color="inherit" sx={{ mr: 1 }}>
              Report Permissions
            </Button>
          )}
          {user && (
            <Button component={NavLink} to="/change-password" color="inherit" sx={{ mr: 1 }}>
              Change Password
            </Button>
          )}
          {user && (
            <Button onClick={onLogout} color="inherit" sx={{ mr: 1 }}>
              Logout
            </Button>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;